/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { cx } from '@emotion/css';
import { Button as MUIButton } from '@mui/material';
import { LoadingButton } from './components/LoadingButton';
import { useButtonStyles } from './Button.styles';
export function Button(props) {
    const classes = useButtonStyles(props);
    const defaultClasses = [props.className];
    const commonDefaultProps = {
        className: cx(...defaultClasses),
        children: props.children,
        classes: {
            root: classes.root,
            contained: classes.contained,
        },
        color: props.color,
        'data-testid': props.testid,
        disabled: props.disabled,
        disableRipple: props.disableRipple,
        endIcon: props.endIcon,
        href: props.href,
        id: props.id,
        onClick: props.onClick,
        onMouseDown: props.onMouseDown,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        rel: props.rel,
        size: props.size,
        startIcon: props.startIcon,
        target: props.target,
    };
    const commonLoadingProps = {
        loading: props.loading,
        disabled: props.loading,
    };
    const mergedCommonProps = Object.assign(Object.assign({}, commonDefaultProps), (props.loading ? commonLoadingProps : {}));
    const ButtonComponent = props.loading ? LoadingButton : MUIButton;
    if (props.variant === 'dashed') {
        return (React.createElement(ButtonComponent, Object.assign({}, mergedCommonProps, { variant: "outlined", className: cx(props.className, classes.dashed) })));
    }
    if (props.variant === 'outlined') {
        return React.createElement(ButtonComponent, Object.assign({}, mergedCommonProps, { variant: "outlined" }));
    }
    if (props.variant === 'contained') {
        return React.createElement(ButtonComponent, Object.assign({}, mergedCommonProps, { variant: "contained" }));
    }
    return React.createElement(ButtonComponent, Object.assign({}, mergedCommonProps, { variant: "text" }));
}
//# sourceMappingURL=Button.js.map